<!--
 * @Description: 商机标签
 * @Author: mdb
 * @Date: 2022-07-01 16:10:07
 * @LastEditTime: 2023-06-25 14:25:58
 * @LastEditors: cxh
-->
<template>
  <a-form scrollToFirstError :model="dataForm" ref="formRef">
    <dc-layout-card :title="props.title" :span="6">
      <dc-form-item label="客户名称" name="saleChanceRefId" :rules="formRules.saleChanceRefId">
        <ClueAndCustomerSelect
          appId="cos_lbu"
          v-model:value="dataForm.saleChanceRefId"
          v-model:label="dataForm.customerName"
          :disabled="!isEdit || props.saleChanceRefId"
          :view="props.type === 'view'"
          :only-customer="true"
          placeholder="请选择客户名称"
        />
      </dc-form-item>
      <dc-form-item name="originCountry" label="始发地国家"  :rules="[{ required: true, message: '请选择' }]">
        <CustomerArea
          v-model:value="dataForm.originCountry"
          change-on-select
          showSearch
          :disabled="!isEdit"
          :display-level="1"
          :view="props.type === 'view'"
          allowClear
        />
      </dc-form-item>
      <dc-form-item label="目的地国家" name="requiredCountry" :rules="formRules.requiredCountry">
        <ParamCodesSelect
          v-model:value="dataForm.requiredCountry"
          :options="paramCodeData.lbu_demand_country"
          :disabled="!isEdit"
          :view="props.type === 'view'"
          allowClear
          @change="handleCountryChange"
        />
      </dc-form-item>
      <dc-form-item label="云途产品" name="product" :rules="formRules.product">
        <ParamCodeCascader
          v-if="props.type === 'view'"
          v-model:label="dataForm.productName"
          v-model:value="dataForm.product"
          :options="paramCodeData.lbu_shipping_channel"
          :disabled="!isEdit"
          :view="props.type === 'view'"
          @change="handleProductNameChange"
        />
        <CosSelect
          v-else
          v-model:value="dataForm.product"
          :options="shippingChannel"
          :fieldNames="{ label: 'cnName', value: 'paramId' }"
          allowClear
        />
      </dc-form-item>
      <dc-form-item label="客户归属区域" name="warehouseAttribution" :rules="formRules.warehouseAttribution">
        <ParamCodeCascader
          v-model:label="dataForm.warehouseAttributionName"
          v-model:value="dataForm.warehouseAttribution"
          :options="paramCodeData.lbu_warehouse_city"
          :disabled="!isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item label="商机状态" name="status" :rules="formRules.status">
        <template #label>
          商机状态
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '900px' }">
            <template #title>
              <div v-for="item in businessStatusEnumFilter" :key="item.value">
                <p>{{ item.label }}{{ item.desc ? `：${item.desc}` : '' }}</p>
              </div>
            </template>
            <ExclamationCircleOutlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <CosSelect
          v-model:value="dataForm.status"
          :options="businessStatusEnumFilter"
          :disabled="!isEdit"
          :view="props.type === 'view'"
          allowClear
        />
      </dc-form-item>
      <dc-form-item label="商机类型" name="saleChanceType" :rules="formRules.saleChanceType">
        <ParamCodesSelect
          v-model:value="dataForm.saleChanceType"
          :options="paramCodeData.lbu_sale_chance_type"
          :disabled="!isEdit"
          :view="props.type === 'view'"
          allowClear
          :max-tag-count="!isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item label="竞争对手" name="competitors" :rules="formRules.competitors">
        <ParamCodeCascader
          v-model:value="dataForm.competitors"
          :options="paramCodeData.lbu_logistics_service_provider"
          :disabled="!isEdit"
          :view="props.type === 'view'"
          allowClear
          multiple
          mode="multiple"
          :max-tag-count="!isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item label="协助部门" name="assistDepartment">
        <ParamCodesSelect
          v-model:value="dataForm.assistDepartment"
          :options="paramCodeData.lbu_assistance_department"
          :disabled="!isEdit"
          :view="props.type === 'view'"
          allowClear
        />
      </dc-form-item>
      <dc-form-item
        label="未能合作原因"
        name="failedCooperateId"
        :rules="formRules.failedCooperateId"
        v-if="isFailedCooperation"
      >
        <ParamCodesSelect
          v-model:value="dataForm.failedCooperateId"
          :options="paramCodeData.lbu_failure_reason"
          :disabled="!isEdit"
          :view="props.type === 'view'"
          allowClear
        />
      </dc-form-item>
      <template v-if="props.type === 'view'">
        <dc-form-item label="客户ID">
          <CosInput v-model:value="dataForm.saleChanceRefId" view />
        </dc-form-item>
        <dc-form-item label="商机名称">
          <CosInput v-model:value="dataForm.saleChanceNameByTxt" view />
        </dc-form-item>
        <dc-form-item label="商机ID">
          <CosInput v-model:value="dataForm.id" view />
        </dc-form-item>
        <dc-form-item label="客户负责人">
          <CosInput v-model:value="dataForm.dutyByName" view />
        </dc-form-item>
        <dc-form-item label="联系人姓名">
          <CosInput v-model:value="dataForm.contactName" view />
        </dc-form-item>
        <dc-form-item label="手机号">
          <CosInput v-model:value="dataForm.contactMobile" view />
        </dc-form-item>
        <dc-form-item label="创建人">
          <CosInput v-model:value="dataForm.createByName" view />
        </dc-form-item>
        <dc-form-item label="创建时间">
          <CosInput v-model:value="dataForm.createTime" view />
        </dc-form-item>
        <dc-form-item label="更新人">
          <CosInput v-model:value="dataForm.updateByName" view />
        </dc-form-item>
        <dc-form-item label="更新时间">
          <CosInput v-model:value="dataForm.updateTime" view />
        </dc-form-item>
      </template>
      <dc-form-item label="OPR票数" name="mau" :rules="isB2BProduct ? undefined : formRules.mau">
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <p>潜力月均发货量</p>
            </template>
            <span>OPR票数</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
<!--        <CosTextarea v-model:value="dataForm.mau" :maxlength="2000" :disabled="!isEdit" :view="props.type === 'view'" />-->
        <CosInputNumber
          style="width: 100%"
          :min="0"
          :maxlength="15"
          cos-type="money"
          v-model:value="dataForm.mau"
          :disabled="!isEdit"
          placeholder="请输入OPR票数"
          :view="props.type === 'view'"
          oninput="value= value.length === 1 ? value.replace(/[^1-9]/g,''):value.replace(/[^\d]/g,'')"
        />
      </dc-form-item>
      <dc-form-item label="OPR金额" name="planSaleAmount" :rules="isB2BProduct ? undefined : formRules.planSaleAmount">
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <p>潜力月均销售额(元)</p>
            </template>
            <span>OPR金额</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <CosInputNumber
          style="width: 100%"
          :min="0"
          :maxlength="15"
          cos-type="money"
          v-model:value="dataForm.planSaleAmount"
          :disabled="!isEdit"
          oninput="value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\d.]/g, '')"
          placeholder="对应仓库及渠道的OPR金额"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item label="OCR票数" name="committedShipment" :rules="isB2BProduct ? undefined : formRules.committedShipment">
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <p>客户承诺月均发货量</p>
            </template>
            <span>OCR票数</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <!--        <CosTextarea v-model:value="dataForm.mau" :maxlength="2000" :disabled="!isEdit" :view="props.type === 'view'" />-->
        <CosInputNumber
          style="width: 100%"
          :min="0"
          :maxlength="15"
          cos-type="money"
          v-model:value="dataForm.committedShipment"
          :disabled="!isEdit"
          placeholder="请输入OCR票数"
          :view="props.type === 'view'"
          oninput="value= value.length === 1 ? value.replace(/[^1-9]/g,''):value.replace(/[^\d]/g,'')"
        />
      </dc-form-item>
      <dc-form-item label="OCR金额" name="committedSaleAmount" :rules="isB2BProduct ? undefined : formRules.committedSaleAmount">
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <p>客户承诺月均销售额（元）</p>
            </template>
            <span>OCR金额</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <!--        <CosTextarea v-model:value="dataForm.mau" :maxlength="2000" :disabled="!isEdit" :view="props.type === 'view'" />-->
        <CosInputNumber
          style="width: 100%"
          :min="0"
          :maxlength="15"
          cos-type="money"
          v-model:value="dataForm.committedSaleAmount"
          :disabled="!isEdit"
          placeholder="请输入OCR金额"
          :view="props.type === 'view'"
          oninput="value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\d.]/g, '')"
        />
      </dc-form-item>
      <template v-if="isB2BProduct">
        <dc-form-item label="OPR重量（KG）" name="oprWeight" :rules="formRules.required">
          <CosInputNumber
            style="width: 100%"
            :min="0"
            :maxlength="15"
            cos-type="money"
            v-model:value="dataForm.oprWeight"
            :disabled="!isEdit"
            placeholder="请输入OPR重量"
            :view="props.type === 'view'"
            oninput="value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\d.]/g, '')"
          />
        </dc-form-item>
        <dc-form-item label="OCR重量（KG）" name="ocrWeight" :rules="dataForm.status === 4 || dataForm.status === 9 ? formRules.required : undefined">
          <CosInputNumber
            style="width: 100%"
            :min="0"
            :maxlength="15"
            cos-type="money"
            v-model:value="dataForm.ocrWeight"
            :disabled="!isEdit"
            placeholder="请输入OCR重量"
            :view="props.type === 'view'"
            oninput="value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\d.]/g, '')"
          />
        </dc-form-item>
        <dc-form-item label="OPR方数（m³）" name="oprCube">
          <CosInputNumber
            style="width: 100%"
            :min="0"
            :maxlength="15"
            cos-type="money"
            v-model:value="dataForm.oprCube"
            :disabled="!isEdit"
            placeholder="请输入OPR方数"
            :view="props.type === 'view'"
            oninput="value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\d.]/g, '')"
          />
        </dc-form-item>
        <dc-form-item label="OCR方数（m³）" name="ocrCube">
          <CosInputNumber
            style="width: 100%"
            :min="0"
            :maxlength="15"
            cos-type="money"
            v-model:value="dataForm.ocrCube"
            :disabled="!isEdit"
            placeholder="请输入OCR方数"
            :view="props.type === 'view'"
            oninput="value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\d.]/g, '')"
          />
        </dc-form-item>
        <dc-form-item label="发货频次（次/月）" name="shipmentFrequency" :rules="formRules.shipmentFrequency">
          <CosInputNumber
            style="width: 100%"
            :min="0"
            :maxlength="15"
            cos-type="money"
            v-model:value="dataForm.shipmentFrequency"
            :disabled="!isEdit"
            placeholder="请输入发货频次"
            :view="props.type === 'view'"
            oninput="value=value.length === 1 ? value.replace(/[^1-9]/g, '') : value.replace(/[^\d.]/g, '')"
          />
        </dc-form-item>
        <dc-form-item label="货物品类" name="goodsCategory" :rules="formRules.goodsCategory">
          <ParamCodesSelect
            v-model:value="dataForm.goodsCategory"
            :options="paramCodeData.lbu_sales_category"
            :disabled="!isEdit"
            :view="props.type === 'view'"
            allowClear
            mode="multiple"
            :max-tag-count="!isEdit ? 100 : 'responsive'"
          />
        </dc-form-item>
      </template>
      <dc-form-item label="经营模式" name="managementModel" class="form-item_compact">
        <a-input-group compact class="cos-view-input-group">
          <ParamCodeCascader
            v-model:value="dataForm.managementModel"
            :cosDes="dataForm.managementModelExplain"
            appId="cos_lbu"
            paramCode="lbu_management_model"
            :status="props.type === 'view' ? undefined : 0"
            :disabled="!isEdit"
            :view="props.type === 'view'"
            style="width: 33%"
          />
          <dc-form-item name="managementModelExplain" :span="24" style="width: 67%" class="last-compact">
            <CosInput
              v-model:value="dataForm.managementModelExplain"
              :maxlength="100"
              :disabled="!isEdit"
              :view="props.type === 'view'"
            />
          </dc-form-item>
        </a-input-group>
      </dc-form-item>
      <template v-if="props.type === 'view' && (dataForm.status === 5 || dataForm.status === 7)">
        <dc-form-item label="当月新增收入（元）">
          <CosInput v-model:value="dataForm.cmAdd" view />
        </dc-form-item>
        <dc-form-item label="收入环比增长（元）">
          <CosInput v-model:value="dataForm.hGrowth" view />
        </dc-form-item>
        <dc-form-item label="FTB首月收入（元）">
          <CosInput v-model:value="dataForm.ftbCm" view />
        </dc-form-item>
        <dc-form-item label="FTB客户承诺收入（元）">
          <CosInput v-model:value="dataForm.ftbCurPro" view />
        </dc-form-item>
      </template>
      <a-col :span="24" />
      <dc-form-item label="竞对情况" name="competitionSituation" :span="12" :rules="formRules.competitionSituation">
        <CosTextarea
          v-model:value="dataForm.competitionSituation"
          :maxlength="2000"
          :disabled="!isEdit"
          :placeholder="competitionPlaceholder"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item label="客户情况" name="customerSituation" :span="12" :rules="formRules.customerSituation">
        <CosTextarea
          v-model:value="dataForm.customerSituation"
          :maxlength="2000"
          :disabled="!isEdit"
          :placeholder="customerPlaceholder"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item label="所需支持" name="requiredSupport" :span="12">
        <CosTextarea
          v-model:value="dataForm.requiredSupport"
          :maxlength="2000"
          :disabled="!isEdit"
          placeholder="针对客户商机转换所需要的支持和帮助内容"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item label="备注" name="remark" :span="12" :rules="formRules.remark">
        <CosTextarea
          v-model:value="dataForm.remark"
          :maxlength="2000"
          :disabled="!isEdit"
          placeholder="其他需要特殊说明的内容，客户货品重量情况等"
          :view="props.type === 'view'"
        />
      </dc-form-item>
    </dc-layout-card>
  </a-form>
</template>

<script setup lang="ts">
import { ref, reactive, onMounted, watch, computed } from 'vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import ClueAndCustomerSelect from '@/components/ClueAndCustomerSelect/index.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { Form } from 'ant-design-vue'
import { businessStatusEnum } from '@/views/yuntuSales/commonEnum/dataConfig'
import { countryChannelRelevance } from '@/api/yuntuSales/operationsManage'
import { listByParamCodes } from '@/api/common'
import { selectForNumberValidate } from '@/utils/validate'
import { paramCodesDataFilter, findByIdDeep } from '@/utils/index'
import type { ParamCodeItem } from '@/typings/common'
import type { LbuBusinessEditParams } from '@/typings/api/chanceManage'
import CustomerArea from '@/components/CustomerArea'

const useForm = Form.useForm
const formRef = ref()
const props = defineProps<{
  value: { [key: string]: any }
  title?: string
  type: 'add' | 'edit' | 'view'
  originalStatus?:number
  saleChanceRefId?: boolean
}>()
const businessStatusEnumFilter = ref<any[]>()
const isEdit = computed(() => props.type !== 'view')
const paramCodeData = ref<{
  lbu_demand_country: ParamCodeItem[]
  lbu_shipping_channel: ParamCodeItem[]
  lbu_warehouse_city: ParamCodeItem[]
  lbu_logistics_service_provider: ParamCodeItem[]
  lbu_assistance_department: ParamCodeItem[]
  lbu_failure_reason: ParamCodeItem[]
  lbu_sale_chance_type: ParamCodeItem[]
  lbu_sales_category: ParamCodeItem[]
}>({
  lbu_demand_country: [], // 目的地国家（需求国家）
  lbu_shipping_channel: [], // 出货渠道（云途产品）
  lbu_warehouse_city: [], // 客户归属区域
  lbu_logistics_service_provider: [], // 竞争对手
  lbu_assistance_department: [], // 协助部门
  lbu_failure_reason: [], // 未能合作原因
  lbu_sale_chance_type: [], // 云途商机类型
  lbu_sales_category: [] // 货物品类
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: [
      'lbu_demand_country',
      'lbu_shipping_channel',
      'lbu_warehouse_city',
      'lbu_logistics_service_provider',
      'lbu_assistance_department',
      'lbu_failure_reason',
      'lbu_sale_chance_type',
      'lbu_sales_category'
    ]
  }).then((res) => {
    if (props.type !== 'view') {
      // 递归过滤业务参数状态
      res.data = paramCodesDataFilter(res.data, 0)
    }
    paramCodeData.value = res.data
  })
}
onMounted(() => {
  if (props.type === 'add') {
    businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value === 0)
    dataForm.value.status = 0
    dataForm.value.originCountry = '100000000000000000'
  }
  getByParamCodes()
})

const isB2BProduct = computed(() => {
  const findOne = shippingChannel.value.find((item) => item.paramId === dataForm.value.product)
  // const findOne = findByIdDeep(shippingChannel.value, dataForm.value.product)
  const result = findOne?.comment?.toUpperCase().includes('B2B') === true
  return result
})

const competitionPlaceholder = computed(() => {
  if (isB2BProduct.value) {
    return `竞对释放的价格：
竞对释放的账期：
竞对的重量要求：
竞对的方数要求：
竞对的其他情况：`
  }
  return `竞对释放的价格：
竞对释放的账期：
竞对的货量要求：
竞对的其他情况：`
})

const customerPlaceholder = computed(() => {
  if (isB2BProduct.value) {
    return `公司规模：
经营模式：
时效需求：
产品类目：
产品重量（KG）：
产品方数（m³）：
货量占比：
客户账期：
未来发展：`
  }

  return `公司规模：
经营平台：
时效需求：
快线需求：
产品类目：
产品售价：
日均单量：
未来发展：
货量占比：
客户情况：`
})

const checkValidate = (value1: any, value2: any, message: string) => {
  if (!value1 && !value2) {
    return Promise.reject(new Error(message))
  }

  return Promise.resolve()
}

const dataForm = ref<LbuBusinessEditParams>({})

const emit = defineEmits(['update:value'])
watch(
  () => props.value,
  (val) => {
    if (!val) return
    dataForm.value = val
  },
  { deep: true, immediate: true }
)
watch(
  dataForm,
  (val) => {
    emit('update:value', val)
  },
  { deep: true }
)
// 根据“目的地国家（需求国家）”的变化获取“出货渠道”
const shippingChannel = ref<ParamCodeItem[]>([])
const getShippingChannel = (val: number) => {
  const params = { paramId: val }
  countryChannelRelevance(params).then((res) => {
    shippingChannel.value = res.data
  })
}
watch(
  () => dataForm.value.requiredCountry,
  (newVal) => {
    if (newVal && newVal !== -9) {
      getShippingChannel(newVal)
    }
  }
)
const handleCountryChange = (val?: number) => {
  dataForm.value.product = undefined
  shippingChannel.value = []
}

const isFailedCooperation = ref(false)
// 客户承诺月均发货量（OCR票数） 客户承诺月均销售额（OCR金额）在商机状态变为【签约】、【准备发件】、【首次发件】、【达到承诺业务量】时，必填
const isRequired = ref(false)
const formRules = reactive({
  saleChanceRefId: [{ required: true, message: '请选择客户名称' }],
  planSaleAmount: [{ required: true && props.type !== 'view', message: '请输入OPR金额' }],
  status: [{ required: true, validator: selectForNumberValidate, message: '请选择商机状态' }],
  requiredCountry: [{ required: true, validator: selectForNumberValidate, message: '请选择目的地国家' }],
  product: [{ required: true, validator: selectForNumberValidate, message: '请选择云途产品' }],
  warehouseAttribution: [{ required: true, message: '请选择客户归属区域' }],
  competitors: [{ required: true, message: '请选择竞争对手' }],
  saleChanceType: [{ required: true, message: '请选择商机类型' }],
  failedCooperateId: [
    { required: isFailedCooperation, validator: selectForNumberValidate, message: '请选择未能合作原因' }
  ],
  remark: [{ required: isFailedCooperation, message: '请输入备注' }],
  mau: [{ required: true && props.type !== 'view', message: '请输入OPR票数' }],
  committedShipment: [{ required: isRequired, message: '请输入OCR票数' }],
  committedSaleAmount: [{ required: isRequired, message: '请输入OCR金额' }],
  competitionSituation: [{ required: true, message: '请输入竞对情况' }],
  customerSituation: [{ required: true, message: '请输入客户情况' }],
  required: [{ required: true, message: '请输入' }],
  goodsCategory: [{ required: true, message: '请选择货物类型' }],
  shipmentFrequency: [{ required: true, message: '请输入发货频次' }],
})
const { resetFields, clearValidate } = useForm(dataForm, formRules)
watch(() => props.originalStatus,
  (val) => {
    const currentStatus = props.originalStatus
    console.log(currentStatus)
    if (currentStatus === null || currentStatus === undefined) {
      return
    }
    switch (props.type) {
      case 'view':
        businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value === currentStatus)
        // businessStatusEnumFilter.value = businessStatusEnum.map((item) => ({ ...item, disabled: props.type === 'add' && item.value === 6 }))
        break
      case 'edit':
        // 编辑的时候，状态只能往下选
        // 未能合作6或者未来机会8 不受控制
        if (currentStatus === 6 || currentStatus === 8) {
          businessStatusEnumFilter.value = businessStatusEnum.map((item) => ({ ...item, disabled: ![0, 6, 8].includes(item.value) }))
        } else if (currentStatus === 7) {
          // 如果商机状态7达成承诺业务量，则不可变更为其他状态（新版【达到承诺业务量】商机状态可以变更为【不能合作】与【未来机会】）
          businessStatusEnumFilter.value = businessStatusEnum.map((item) => ({ ...item, disabled: item.value !== 6 && item.value !== 8 }))
        } else if (currentStatus === 9) {
          // 准备发件
          businessStatusEnumFilter.value = businessStatusEnum.map((item) => ({ ...item, disabled: item.value < 5 || item.value === 5 || item.value === 7 }))
        } else {
          // 其余状态只可以向后变更
          businessStatusEnumFilter.value = businessStatusEnum.map((item) => ({ ...item, disabled: item.value < currentStatus || item.value === 5 || item.value === 7 }))
        }
        break
    }
  })
watch(
  () => dataForm.value.status,
  (val) => {
    isFailedCooperation.value = val === 6
    isRequired.value = (val === 4 || val === 9 || val === 5 || val === 7) && props.type !== 'view'
    setTimeout(() => clearValidate(['failedCooperateId', 'remark']), 0)
  },
  { immediate: true }
)

const handleProductNameChange = (value: number[]) => {
  // dataForm.productName = value[0]
}
const validate = () => {
  return new Promise((resolve, reject) => {
    formRef.value
      ?.validate()
      .then(async (res: any) => {
        resolve(res)
      })
      .catch((err: any) => {
        reject(err)
      })
  })
}

defineExpose({ resetFields, validate, clearValidate })
</script>
<script lang="ts">
export default { name: 'BusinessForm' }
</script>

<style scoped></style>
